var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.725,
    height: 129.269,
    viewBox: "0 0 159.725 129.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty_item",
    transform: "translate(0.034 -48.8)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6794",
    "data-name": "Path 6794",
    d: "M214.207,73.054v7.518H140.4s-4.9.749-4.9-4.9V61.762s-.749-3.962,3.962-3.962h23.52l6.02,9.982h40.677S214.207,68.531,214.207,73.054Z",
    transform: "translate(-93.228 -6.193)",
    fill: "#36c96d",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7146",
    "data-name": "Group 7146",
    transform: "translate(34.712 56.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6795",
    "data-name": "Path 6795",
    d: "M116.483,141.8a5.142,5.142,0,0,1-3.369-1.154,5.636,5.636,0,0,1-1.716-4.523V77.073a4.314,4.314,0,0,1,.842-3.275,4.723,4.723,0,0,1,3.868-1.5h23.52a.769.769,0,0,1,.655.374l5.8,9.608h40.365A6.1,6.1,0,0,1,191.6,88.3v52.718a.759.759,0,0,1-.749.749H117.076A2.714,2.714,0,0,1,116.483,141.8Zm-.374-67.972a3.4,3.4,0,0,0-2.714.936,2.907,2.907,0,0,0-.5,2.121v59.238a4.259,4.259,0,0,0,1.217,3.4,3.849,3.849,0,0,0,2.807.749H190.1V88.3a4.6,4.6,0,0,0-3.837-4.523H145.65a.769.769,0,0,1-.655-.374l-5.8-9.608H116.109Z",
    transform: "translate(-111.352 -72.3)",
    fill: "#3d4977",
    stroke: "#3d4977",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2989",
    "data-name": "Ellipse 2989",
    cx: 51.814,
    cy: 10.013,
    rx: 51.814,
    ry: 10.013,
    transform: "translate(48.265 158.042)",
    fill: "#3d4977",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7147",
    "data-name": "Group 7147",
    transform: "translate(122.484 145.198)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 2.277,
    y2: 2.246,
    transform: "translate(0.741 0.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    "data-name": "Path 6796",
    d: "M395.712,361.56a.731.731,0,0,1-.53-.218l-2.246-2.246A.75.75,0,1,1,394,358.036l2.246,2.246a.773.773,0,0,1,0,1.061A.643.643,0,0,1,395.712,361.56Z",
    transform: "translate(-392.725 -357.825)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7148",
    "data-name": "Group 7148",
    transform: "translate(126.259 142.203)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 2.246,
    y2: 2.277,
    transform: "translate(0.741 0.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6797",
    "data-name": "Path 6797",
    d: "M407.812,351.961a.731.731,0,0,1-.53-.218l-2.246-2.246a.75.75,0,0,1,1.061-1.061l2.246,2.246a.773.773,0,0,1,0,1.061A.684.684,0,0,1,407.812,351.961Z",
    transform: "translate(-404.825 -348.225)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2990",
    "data-name": "Ellipse 2990",
    cx: 33.877,
    cy: 33.877,
    r: 33.877,
    transform: "translate(70.538 84.954)",
    fill: "#ccf2da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7149",
    "data-name": "Group 7149",
    transform: "translate(64.518 84.205)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2991",
    "data-name": "Ellipse 2991",
    cx: 33.877,
    cy: 33.877,
    r: 33.877,
    transform: "translate(0.749 0.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6798",
    "data-name": "Path 6798",
    d: "M241.526,231.551a34.626,34.626,0,1,1,34.626-34.626A34.667,34.667,0,0,1,241.526,231.551Zm0-67.754a33.128,33.128,0,1,0,33.128,33.128A33.149,33.149,0,0,0,241.526,163.8Z",
    transform: "translate(-206.9 -162.3)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7150",
    "data-name": "Group 7150",
    transform: "translate(69.789 89.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6799",
    "data-name": "Path 6799",
    d: "M253.154,237.908a29.354,29.354,0,1,1,29.354-29.354A29.382,29.382,0,0,1,253.154,237.908Zm0-57.21a27.856,27.856,0,1,0,27.856,27.856A27.9,27.9,0,0,0,253.154,180.7Z",
    transform: "translate(-223.8 -179.2)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7151",
    "data-name": "Group 7151",
    transform: "translate(152.766 105.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6800",
    "data-name": "Path 6800",
    d: "M493.263,237.125a3.463,3.463,0,1,1,3.463-3.463A3.475,3.475,0,0,1,493.263,237.125Zm0-6.02a2.558,2.558,0,1,0,2.558,2.558A2.57,2.57,0,0,0,493.263,231.1Z",
    transform: "translate(-489.8 -230.2)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2992",
    "data-name": "Ellipse 2992",
    cx: 1.497,
    cy: 1.497,
    r: 1.497,
    transform: "translate(154.731 107.352)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7152",
    "data-name": "Group 7152",
    transform: "translate(35.131 78.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6801",
    "data-name": "Path 6801",
    d: "M191.742,144.9H113.507a.786.786,0,0,1-.811-.686.755.755,0,0,1,.749-.811h78.3a.742.742,0,0,1,.749.561A.76.76,0,0,1,191.742,144.9Z",
    transform: "translate(-112.694 -143.4)",
    fill: "#3d4977",
    stroke: "#3d4977",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7155",
    "data-name": "Group 7155",
    transform: "translate(1.973 54.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7153",
    "data-name": "Group 7153",
    transform: "translate(4.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6802",
    "data-name": "Path 6802",
    d: "M21.749,78.644A.759.759,0,0,1,21,77.895V68.849a.749.749,0,0,1,1.5,0v9.046A.759.759,0,0,1,21.749,78.644Z",
    transform: "translate(-21 -68.1)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7154",
    "data-name": "Group 7154",
    transform: "translate(0 4.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6803",
    "data-name": "Path 6803",
    d: "M16.195,84.1H7.149a.749.749,0,1,1,0-1.5h9.046a.759.759,0,0,1,.749.749A.739.739,0,0,1,16.195,84.1Z",
    transform: "translate(-6.4 -82.6)",
    fill: "#3d4977"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7158",
    "data-name": "Group 7158",
    transform: "translate(83.148 108.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7156",
    "data-name": "Group 7156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6804",
    "data-name": "Path 6804",
    d: "M267.366,246.809a.731.731,0,0,1-.53-.218.773.773,0,0,1,0-1.061l6.395-6.395a.75.75,0,0,1,1.061,1.061l-6.395,6.395A.731.731,0,0,1,267.366,246.809Z",
    transform: "translate(-266.625 -238.925)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7157",
    "data-name": "Group 7157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6805",
    "data-name": "Path 6805",
    d: "M273.761,246.809a.731.731,0,0,1-.53-.218l-6.395-6.395a.75.75,0,1,1,1.061-1.061l6.395,6.395a.773.773,0,0,1,0,1.061A.731.731,0,0,1,273.761,246.809Z",
    transform: "translate(-266.625 -238.925)",
    fill: "#3d4977"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7161",
    "data-name": "Group 7161",
    transform: "translate(108.01 108.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7159",
    "data-name": "Group 7159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6806",
    "data-name": "Path 6806",
    d: "M347.066,246.809a.731.731,0,0,1-.53-.218.773.773,0,0,1,0-1.061l6.395-6.395a.75.75,0,0,1,1.061,1.061l-6.395,6.395A.731.731,0,0,1,347.066,246.809Z",
    transform: "translate(-346.325 -238.925)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7160",
    "data-name": "Group 7160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6807",
    "data-name": "Path 6807",
    d: "M353.429,246.809a.731.731,0,0,1-.53-.218l-6.364-6.395a.75.75,0,0,1,1.061-1.061l6.395,6.395a.773.773,0,0,1,0,1.061A.752.752,0,0,1,353.429,246.809Z",
    transform: "translate(-346.325 -238.925)",
    fill: "#3d4977"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7164",
    "data-name": "Group 7164",
    transform: "translate(138.292 48.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7162",
    "data-name": "Group 7162",
    transform: "translate(6.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6808",
    "data-name": "Path 6808",
    d: "M465.849,63.867a.759.759,0,0,1-.749-.749V49.549a.749.749,0,1,1,1.5,0v13.57A.739.739,0,0,1,465.849,63.867Z",
    transform: "translate(-465.1 -48.8)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7163",
    "data-name": "Group 7163",
    transform: "translate(0 6.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6809",
    "data-name": "Path 6809",
    d: "M457.718,72h-13.57a.749.749,0,0,1,0-1.5h13.57a.749.749,0,0,1,0,1.5Z",
    transform: "translate(-443.4 -70.5)",
    fill: "#3d4977"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7165",
    "data-name": "Group 7165",
    transform: "translate(93.871 124.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6810",
    "data-name": "Path 6810",
    d: "M301,299.523A5.733,5.733,0,0,1,307.02,295s6.02,0,6.02,4.523",
    transform: "translate(-301 -294.251)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6811",
    "data-name": "Path 6811",
    d: "M301.9,297.716h-.031a.719.719,0,0,1-.717-.9c.405-1.5,1.778-4.211,6.27-4.211,2.184,0,5.3.686,6.02,4.43a.7.7,0,0,1-.686.842h-.031a.678.678,0,0,1-.686-.593c-.437-3.119-4.4-3.151-4.617-3.151-3.587,0-4.586,2.09-4.866,3.088A.8.8,0,0,1,301.9,297.716Z",
    transform: "translate(-301.084 -292.6)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7166",
    "data-name": "Group 7166",
    transform: "translate(124.941 143.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6812",
    "data-name": "Path 6812",
    d: "M426.382,379.582h0a6.119,6.119,0,0,1-8.672,0L404.826,366.7a6.119,6.119,0,0,1,0-8.672h0a6.119,6.119,0,0,1,8.672,0l12.883,12.883A6.119,6.119,0,0,1,426.382,379.582Z",
    transform: "translate(-402.269 -355.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6813",
    "data-name": "Path 6813",
    d: "M420.377,380.474a6.871,6.871,0,0,1-4.866-2l-12.883-12.883a6.853,6.853,0,0,1,0-9.733,6.891,6.891,0,0,1,9.733,0l12.883,12.883a6.853,6.853,0,0,1,0,9.733h0A6.818,6.818,0,0,1,420.377,380.474Zm-12.883-25.111a5.465,5.465,0,0,0-3.806,1.56,5.3,5.3,0,0,0-1.56,3.806,5.436,5.436,0,0,0,1.56,3.806l12.883,12.883a5.366,5.366,0,0,0,7.58,0h0a5.3,5.3,0,0,0,1.56-3.806,5.435,5.435,0,0,0-1.56-3.806l-12.883-12.883A5.285,5.285,0,0,0,407.494,355.363Zm17.219,22.585Z",
    transform: "translate(-400.6 -353.85)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6814",
    "data-name": "Path 6814",
    d: "M.164,275.319l10.107,19.153a1.65,1.65,0,0,0,2.277.717l14.193-7.611a1.682,1.682,0,0,0,.655-2.308L16.1,264.9.85,273.042A1.692,1.692,0,0,0,.164,275.319Z",
    transform: "translate(0 -148.689)",
    fill: "#36c96d",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7167",
    "data-name": "Group 7167",
    transform: "translate(4.31 115.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6815",
    "data-name": "Path 6815",
    d: "M25.468,292.243a2.376,2.376,0,0,1-.655-.094,2.179,2.179,0,0,1-1.31-1.092l-9.358-18.03h0a2.215,2.215,0,0,1,.936-2.995l11.542-6.176a.466.466,0,0,1,.406-.031l5.677,1.591a.45.45,0,0,1,.343.281l8.61,15.691a2.334,2.334,0,0,1,.187,1.716,2.138,2.138,0,0,1-1.092,1.341L26.56,292.056A4.449,4.449,0,0,1,25.468,292.243ZM15.111,272.466,24.47,290.5a1.169,1.169,0,0,0,.655.561,1,1,0,0,0,.842-.094l14.193-7.611a1.1,1.1,0,0,0,.53-.655,1,1,0,0,0-.094-.842l-8.485-15.472-5.241-1.466-11.324,6.052a1.186,1.186,0,0,0-.437,1.5Z",
    transform: "translate(-13.893 -263.791)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7168",
    "data-name": "Group 7168",
    transform: "translate(16.695 115.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6816",
    "data-name": "Path 6816",
    d: "M56.342,268.883a.234.234,0,0,1-.156-.031.606.606,0,0,1-.343-.281l-2.184-4.086a.562.562,0,0,1,.062-.624.533.533,0,0,1,.624-.156l5.958,2.028a.506.506,0,0,1,.374.5.525.525,0,0,1-.281.53l-3.775,2.028A.5.5,0,0,1,56.342,268.883Zm-1-3.65,1.248,2.308,2.152-1.154Z",
    transform: "translate(-53.595 -263.662)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7169",
    "data-name": "Group 7169",
    transform: "translate(9.111 122.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6817",
    "data-name": "Path 6817",
    d: "M29.849,291.509a.556.556,0,0,1-.5-.312.535.535,0,0,1,.25-.749l7.58-3.868a.56.56,0,0,1,.749.25.535.535,0,0,1-.25.749l-7.549,3.868A.911.911,0,0,1,29.849,291.509Z",
    transform: "translate(-29.282 -286.526)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7170",
    "data-name": "Group 7170",
    transform: "translate(12.886 129.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6818",
    "data-name": "Path 6818",
    d: "M41.949,312.152a.556.556,0,0,1-.5-.312.535.535,0,0,1,.25-.749L51,306.35a.558.558,0,0,1,.5,1l-9.3,4.742A.588.588,0,0,1,41.949,312.152Z",
    transform: "translate(-41.382 -306.282)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7171",
    "data-name": "Group 7171",
    transform: "translate(14.695 132.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6819",
    "data-name": "Path 6819",
    d: "M47.749,322.5a.556.556,0,0,1-.5-.312.535.535,0,0,1,.25-.749l9.733-4.96a.56.56,0,0,1,.749.25.535.535,0,0,1-.25.749L48,322.438A.734.734,0,0,1,47.749,322.5Z",
    transform: "translate(-47.182 -316.426)",
    fill: "#3d4977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7172",
    "data-name": "Group 7172",
    transform: "translate(10.764 125.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6820",
    "data-name": "Path 6820",
    d: "M35.149,300.852a.556.556,0,0,1-.5-.312.535.535,0,0,1,.25-.749l9.3-4.742a.558.558,0,1,1,.5,1l-9.3,4.742A.336.336,0,0,1,35.149,300.852Z",
    transform: "translate(-34.582 -294.982)",
    fill: "#3d4977"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyItem);
export default __webpack_public_path__ + "static/media/empty_item.19cbc89b1cde633df1bd974225976abf.svg";
export { ForwardRef as ReactComponent };